import React from "react";
import AssignedPlans from "./AssignedPlans";
import TeamProgressTracker from "./TeamProgress";

const PropertyAndTeamTracker: React.FC = () => {
  return (
    <div className="team_progress-assigned_plans">
      <TeamProgressTracker />
      <AssignedPlans />
    </div>
  );
};

export default PropertyAndTeamTracker;
